import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IPreloyderSlice {
  isPreloyder: boolean;
}

const initialState: IPreloyderSlice = {
  isPreloyder: false,
};

const preloyderSlice = createSlice({
  name: "preloyderSlice",
  initialState,
  reducers: {
    setIsPreloyder(state, action: PayloadAction<boolean>) {
      state.isPreloyder = action.payload;
    },
  },
});

export const { setIsPreloyder } = preloyderSlice.actions;
export default preloyderSlice.reducer;
